// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_SubscribeInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_SubscribeInput — body for POST /subscriptions/subscribe.
 *
 * franquia_id and plan_id are required positive integers.
 * provider_code is required — the caller must choose the gateway explicitly;
 * the controller validates it is registered, enabled, and offered for the
 * franchise's country before charging.
 */
import { registerContract } from './validate'

export interface Subscriptions_SubscribeInput {
franquia_id: number
plan_id: number
provider_code: string
}

registerContract('Subscriptions_SubscribeInput', {
  franquia_id:   { type: 'number',  required: true },
  plan_id:       { type: 'number',  required: true },
  provider_code: { type: 'string',  required: true },
})
